/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconUserMinus = createReactComponent("outline", "user-minus", "IconUserMinus", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.009 .128", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

export { IconUserMinus as default };
//# sourceMappingURL=IconUserMinus.mjs.map
